import { odata } from '../../conf';

const actions = {
  async LOAD_xeroReportExpenseLineItems({ commit, rootGetters }) {
    const data = await odata.o(rootGetters)
      .get('xeroReportExpenseLineItems')
      .query({ $expand: 'ExpenseDocument' });
    commit('SET_xeroReportExpenseLineItems', data);
  },
};

export default actions;
